<template>
    <div :id="dialogId"
         class="modal fade"
         role="dialog"
         :aria-labelledby="`${dialogId}Title`"
         aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered dialog-small"
             role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <label :id="`${dialogId}Title`"
                           class="modal-title">
                        <i class="icon icon-export" />
                        Save preset
                    </label>
                </div>
                <div class="modal-body">
                    <label>Preset name</label>
                    <input v-model="presetName"
                           autocomplete="off"
                           type="text">
                </div>
                <div class="modal-footer left-align">
                    <div class="ms-auto">
                        <button type="button"
                                class="btn btn-color btn-outline-primary btn-sm"
                                @click="cancelSave">
                            Go Back
                        </button>
                        <update-button button-label="Save"
                                       :sending="sending"
                                       :disabled="!canSave"
                                       @click="saveConfirm" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { defineProps, defineEmits, defineExpose, onMounted, computed, ref } from 'vue';
    import axios from 'axios';
    import { axiosError, axiosConfig } from '../../js/AjaxUtilities.js';
    import UpdateButton from '../UpdateButton.vue';
    import { modalDialog } from '../../js/ModalDialog.js';

    const props = defineProps({
        data: { // The thing to save
            type: Object,
            default: null
        },
        idNumber: { // number to make dialog unique
            type: Number,
            default: 0
        },
        type: { // type number. 0 = Recovery Goal, 1 = Relapse Prevention
            type: Number,
            default: 0
        },
        goalPlanId: {
            type: Number,
            default: 0
        }
    });

    function show() {
        modalDialog.openModal(dialogId.value);
    }

    const dialogId = computed(() => `save-preset-dialog-${props.idNumber}`);

    const canSave = computed(() => {
        return !!presetName.value && presetName.value.trim().length > 0;
    });

    const presetName = ref(null);
    const sending = ref(false);

    function cancelSave() {
        modalDialog.closeModal(dialogId.value);
    }

    function saveConfirm() {
        sending.value = true;
        let data = {
            name: presetName.value,
            goalPlanId: props.goalPlanId,
            item: props.data
        };

        let url = (props.type == 0) ? "SaveRecoveryGoalPreset" : "SaveRelapsePreventionPreset";

        axios
            .post(`/GoalPlan/${url}`, data, axiosConfig())
            .then(function (response) {
                if (!response.data.success) {
                    alert(`Failed to save preset: ${response.data.message}`);
                }
            })
            .catch(function (error) {
                axiosError("Save preset", axios, error);
            })
            .finally(() => {
                sending.value = false;
                modalDialog.closeModal(dialogId.value);
            })
    }

    defineExpose({
        show
    });

</script>
